export default __webpack_public_path__ + "static/media/nft-8.2709778b.png";